import React from 'react'
import { Route } from 'react-router-dom'
import PhoneSuccess from './PhoneSuccess';

import { phoneSuccess } from "../../../constants/routePaths"

const PhoneSuccessRoute = [
  <Route
    key="PhoneSuccess"
    exact path={phoneSuccess}
    component={PhoneSuccess}
  />,
];

export default PhoneSuccessRoute